import type { IconData } from '@stacksjs/iconify-core'

export const swordF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9.646 14.096a1 1 0 1 1-1.414 1.414l-1.414-1.414l-2.828 2.829a1 1 0 0 1-1.415 1.414l-1.414-1.414a1 1 0 0 1 1.414-1.415l2.829-2.828l-1.414-1.414a1 1 0 0 1 1.414-1.414zm.708-.707L6.11 9.146L14.596.661l3.536.707l.707 3.536z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default swordF
